/**
 * @param availableTokenBalance - totalBalance minus lockedBalance in user wallet
 * @param amount
 * @returns boolean
 */
export const hasEnoughAvailableToken = (availableTokenBalance: number) => (amount: number | string) => {
	if (availableTokenBalance >= Number(amount)) return true;
	else return false;
};

/**
 * @param totalTokenRequired - totalTokenRequired by the product or auction
 * @param combinedWalletTokens - combined balance of all the wallets
 * @returns boolean
 */
export const hasEnoughTokenCombinedWallet = (totalTokenRequired: number, combinedWalletTokens: number) => {
	if (isNaN(Number(combinedWalletTokens))) {
		combinedWalletTokens = 0;
	}

	return Number(combinedWalletTokens) >= totalTokenRequired;
};
